// import * as storage from './storage'
import {KEYS} from './constants'
import Vue from "vue";

const specialCharacter = ['#', '$', '&', '<']
export const checkSpecialCharacter = text => {
    for (let i=0; i< specialCharacter.length; i++) {
        if (text.indexOf(specialCharacter[i]) >= 0) {
            return true
        }
    }
    return false
}

const MAX_FILE_LENGTH = 10
export const maxFileLength = 1024 * 1024 * MAX_FILE_LENGTH
export const maxFileWarning = '文件大小不能超过' + MAX_FILE_LENGTH + 'M'
export const maxFileTip = '且不超过' + MAX_FILE_LENGTH + 'M'


const aCity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  }

export const isManageRole = (userRoles) => {
    if (!userRoles) return false
    let manageRole = userRoles.filter(item => {return item.roleCode == 'MANAGE'})
    if (manageRole && manageRole.length) {
        return true
    }
    return false
}
    /**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}
/**
 * 存储sessionStorage
 */
export const setStoreSession = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
}

/**
 * 获取sessionStorage
 */
export const getStoreSession = name => {
    if (!name) return;
    return window.sessionStorage.getItem(name);
}

/**
 * 删除sessionStorage
 */
export const removeStoreSession = name => {
    if (!name) return;
    window.sessionStorage.removeItem(name);
};

// 用户缓存，避免重复读取缓存
const CACHED = {}

// 设置缓存
const setCache = (key, val) => {
    CACHED[key] = val

    return storage.setItem(key, val)
}

// 获取缓存
const getCache = key => {
    if (CACHED[key]) {
        return CACHED[key]
    }

    CACHED[key] = storage.getItemSync(key)

    return CACHED[key]
}

// 移除缓存
const removeCache = key => {
    delete CACHED[key]

    return storage.removeItem(key)
}

/**
 * 生成全局唯一标识
 */
const generateUUID = () => {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};
let deviceId = generateUUID()

// 唯一标识 是否生成
let deviceIdIs = () => {
    if (!getStore('deviceId')) {
        setStore('deviceId', deviceId)
    } else {
        getStore('deviceId')
    }
}

/**
 * 获取缓存中的token（同步）
 * @return {string} token
 */
export const getToken = () => getCache(KEYS.TOKEN_KEY)

/**
 * 将token保存到缓存中(同步)
 * @param  {string} token
 * @return {undefined}
 */
export const saveToken = val => setCache(KEYS.TOKEN_KEY, val)

/**
 * @date Date类型对象
 * @fmt 格式化字符串  月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *                   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * dateformat(new Date(), "yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * dateformat(new Date(), "yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export const dateformat = (date, fmt) => {
    let o = {
        "M+": date.getMonth() + 1,                 //月份
        "d+": date.getDate(),                    //日
        "h+": date.getHours(),                   //小时
        "m+": date.getMinutes(),                 //分
        "s+": date.getSeconds(),                 //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 * 获取一周内的时间
 * 返回值数组 arr[0]：一周前的那天，arr[1]：今天
 * 例子：
 * getWeeks();  // return ['2018-07-01', '2018-07-08']
 */
export const getWeeks = () => {
    let weeks = [];
    let now = new Date();
    let lastweek = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    weeks.push(dateformat(lastweek, 'yyyy-MM-dd'), dateformat(now, 'yyyy-MM-dd'));
    return weeks;
}

/**
 * 获取一月内的时间
 * 返回值数组 arr[0]：一月前的那天，arr[1]：今天
 * 例子：
 * getWeeks();  // return ['2018-06-08', '2018-07-08']
 */
export const getMonths = () => {
    let months = [];
    let now = new Date();
    months.push(dateformat(now, 'yyyy-MM-dd'));
    let lastmonth = new Date(now.setMonth(now.getMonth() - 1));
    months.push(dateformat(lastmonth, 'yyyy-MM-dd'));
    return months.reverse();
}

/**
 * 获取一年内的时间
 * 返回值数组 arr[0]：一年前的那天，arr[1]：今天
 * 例子：
 * getWeeks();  // return ['2017-07-08', '2018-07-08']
 */
export const getYears = () => {
    let years = [];
    let now = new Date();
    years.push(dateformat(now, 'yyyy-MM-dd'));
    let lastmonth = new Date(now.setFullYear(now.getFullYear() - 1));
    years.push(dateformat(lastmonth, 'yyyy-MM-dd'));
    return years.reverse();
}

/**
 * 获取某元素距离顶部的距离
 * 参数element为该元素的dom对象
 */
export const getElementTop = (element) => {
    let actualTop = element.offsetTop
    let current = element.offsetParent
    while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
    }
    return actualTop
}

/**获取当前URL里的查询参数
 *
 * @param url
 * @returns {{}|*}
 */
export const getUrlParams = url => {
    url = url || window.location.href;
    let queryArray = url.split(/[?&#]/).slice(1);
    let i;
    let args = {};
    for (i = 0; i < queryArray.length; i++) {
        let match = queryArray[i].match(/([^=]+)=([^=]+)/);
        if (match !== null) {
            args[match[1]] = decodeURIComponent(match[2]);
        }
    }
    return args;
}

export const getdeviceId = () => deviceIdIs()

export const funs = undefined
export const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        const reg = /^1[3-9]\d{9}$/
        console.log(reg.test(value));
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
};

export const checkSpecialChar = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('内容不能为空'));
    } else {
        if (value.indexOf('&') >= 0) {
            return callback(new Error('不支持特殊字符&'));
        } else {
            if (value.indexOf('<') >= 0) {
                return callback(new Error('不支持特殊字符<'));
            } else {
                callback();
            }
        }
    }
};

export const checkIdCard = (rule, value, callback) => {
    if (value == "" || value.toString().trim() == '') {
        return callback(new Error('身份证号不能为空'));
    } else {
        let iSum = 0;
        if (!/^\d{17}(\d|x)$/i.test(value)) return callback(new Error('您输入的身份证长度或格式错误'));
        // value = value.replace(/x$/i, "a");
        if (aCity[parseInt(value.substr(0, 2))] == null) return callback(new Error('您的身份证地区非法'));
        let sBirthday = value.substr(6, 4) + "-" + Number(value.substr(10, 2)) + "-" + Number(value.substr(12, 2));
        let d = new Date(sBirthday.replace(/-/g, "/"));
        if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return callback(new Error('身份证上的出生日期非法'));
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('您输入的身份证号非法'));
        }
        // for (let i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(value.charAt(17 - i), 11);
        // if (iSum % 11 != 1) return callback(new Error('您输入的身份证号非法'));
        // callback();
    }
};

export const toastSuc = (msg) => {
    Vue.prototype.$message.success(msg)
}
export const toastError = (msg) => {
    Vue.prototype.$message.error(msg)
}
export const toastWarning = (msg) => {
    Vue.prototype.$message.warning(msg)
}


 export  const   getFileExtendName=(fileName)=>{
    let startIndex = fileName.lastIndexOf(".");
    if(startIndex != -1)
        return fileName.substring(startIndex+1, fileName.length).toLowerCase();
    else return "";
}

// 获取文件类型图
/**
 * 通过路劲 获取文件类型图
 * @param path
 * @returns {string}
 */
 export const getFileTypeImagebyExtName = (path) => {
    if (path == undefined) return null;
    if (path.endsWith("doc") || path.endsWith("docx"))
        return require("../assets/img/ic_word.png"); //doc
    if (path.endsWith("xlsx") || path.endsWith("xls"))
        return require("../assets/img/ic_excel.png"); //表格
    if (path.endsWith("pdf")) return require("../assets/img/ic_pdf.png"); //表格
    if (
        path.endsWith("png") ||
        path.endsWith("jpg") ||
        path.endsWith("jpeg") ||
        path.endsWith("gif") ||
        path.endsWith("bmp") ||
        path.endsWith("webp")
    )
        return require("../assets/img/ic_image.png"); //图片
};
export const getFileTypebyExtName = (path) => {
    if (path.endsWith("doc") || path.endsWith("docx")) return 0; //doc
    if (path.endsWith("xlsx") || path.endsWith("xls")) return 1; //表格
    if (path.endsWith("pdf")) return 2; //表格
    if (
        path.endsWith("png") ||
        path.endsWith("jpg") ||
        path.endsWith("jpeg") ||
        path.endsWith("gif") ||
        path.endsWith("bmp") ||
        path.endsWith("webp")
    )
        return 3; //图片
    if (
        path.endsWith("mp4") ||
        path.endsWith("ogg") ||
        path.endsWith("flv") ||
        path.endsWith("avi") ||
        path.endsWith("wmv") ||
        path.endsWith("rmvb") ||
        path.endsWith("mkv")
    )
        return 4; //视频
};

export const CASE_TYPE_DICTIONARY = [{
    label:"异步庭审",
    value:"ASYNCHRONOUS_TRIAL"
},{
    label:"在线庭审",
    value:"MEDIATION_MEETING"
},{
    label:"异步调解",
    value:"ASYNCHRONOUS_MEDIATE"
},{
    label:"在线送达",
    value:"ONLINE_SERVICE"
}]
export const CASE_TYPE_CODE = {
    ASYNCHRONOUS_TRIAL : 'ASYNCHRONOUS_TRIAL',
    MEDIATION_MEETING : 'MEDIATION_MEETING',
    ASYNCHRONOUS_MEDIATE : 'ASYNCHRONOUS_MEDIATE',
    ONLINE_SERVICE : 'ONLINE_SERVICE',
}
